export function getSignalingUrl(oldPeerId, peerId, roomId) {

	let port = window.config.productionPort;

	// nginx中配置的https端口可能和productionPort不一样，比如nginx中为443，此时window.location.port为空，此时port应该为空
	if (window.location.port !== port) {
		console.log("URL port[%s] diff with config port[%s],use URL port prior.", window.location.port, port);
		port = window.location.port;
	}

	if (port) {
		port = ':' + port;
	}

	let _protocol = window.location.protocol;
	let _ws = 'wss:';
	if (_protocol === 'http:') {
		_ws = 'ws:';
	}

	let url = `${_ws}//${window.location.hostname}${port}/?peerId=${peerId}&roomId=${roomId}`;

	if (oldPeerId) {

		url = url + `&oldPeerId=${oldPeerId}`
	}

	return url;
}
